const WEEKDAYS = [
  "Воскресенье",
  "Понедельник",
  "Вторник",
  "Среда",
  "Четверг",
  "Пятница",
  "Суббота",
];

const MONTHS = [
  "января",
  "февраля",
  "марта",
  "апреля",
  "мая",
  "июня",
  "июля",
  "августа",
  "сентября",
  "октября",
  "ноября",
  "декабря",
];

function parse(date: string): Date {
  const [y, m, d] = date.split("-").map(Number);
  return new Date(y, m - 1, d);
}

/** «Вторник, 1 сентября» */
export function formatDate(date: string): string {
  const value = parse(date);
  return `${WEEKDAYS[value.getDay()]}, ${value.getDate()} ${MONTHS[value.getMonth()]}`;
}

/** «9 сентября» — без дня недели: в строке о прошлом он лишний. */
export function formatDay(date: string): string {
  const value = parse(date);
  return `${value.getDate()} ${MONTHS[value.getMonth()]}`;
}

/** Дней до целевого экзамена. Интервалы считаются от этой даты, не от сегодня. */
export function daysUntil(target: string, from: string): number {
  const ms = parse(target).getTime() - parse(from).getTime();
  return Math.max(0, Math.round(ms / 86400000));
}

/** «231 день», «2 дня», «21 день» */
export function plural(n: number, one: string, few: string, many: string): string {
  const mod100 = n % 100;
  const mod10 = n % 10;
  if (mod100 >= 11 && mod100 <= 14) return many;
  if (mod10 === 1) return one;
  if (mod10 >= 2 && mod10 <= 4) return few;
  return many;
}

/**
 * Момент в «ГГГГ-ММ-ДД» по МЕСТНЫМ часам, а не по UTC.
 *
 * `toISOString().slice(0, 10)` для этого не годится: Минск — UTC+3, и всё
 * после 21:00 по-местному в UTC уже завтра. Дата уезжает на сутки каждый
 * вечер, а по ней сервер режет окно недели.
 */
export function localDate(ms: number): string {
  const d = new Date(ms);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
